import { Autocomplete, Chip, TextField } from "@mui/material"
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface DisplayNamesInputProps {
    displayNames: string[];
    options: string[];
    onChange: (displayNames: string[]) => void;
}
export const DisplayNamesInput = (props: DisplayNamesInputProps) => {
    const { t } = useTranslation();
    const { onChange } = props;

    const handleAutocompleteChange = (event: React.ChangeEvent<{}>, newValue: string[]) => {
        onChange(newValue);
    };

return <Autocomplete
        multiple
        value={props.displayNames}
        onChange={handleAutocompleteChange}
        options={props.options}
        getOptionLabel={(option) => option}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" label={t('sendMessage.users')} placeholder={t('sendMessage.addUser')} />
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              label={option}
              {...getTagProps({ index })}
            />
          ))
        }
      />
}